import { render, staticRenderFns } from "./PresalesMap.vue?vue&type=template&id=66754b82"
import script from "./PresalesMap.vue?vue&type=script&lang=js"
export * from "./PresalesMap.vue?vue&type=script&lang=js"
import style0 from "./PresalesMap.vue?vue&type=style&index=0&id=66754b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports